import { Box } from '@mui/material';
import { ShareIcon } from 'components/icons/ShareIcon';
import React, { CSSProperties, ReactElement, useState } from 'react';
import { Event } from 'services/api';
import { EventSharingWidget, Modal } from 'components/ui';
export interface ShareButtonProps {
  style?: CSSProperties;
  event: Event;
  children: React.ReactNode;
  gap?: number;
  icon?: React.ComponentType<any>;
}

export const ShareEventButton = ({
  style,
  event,
  children,
  gap,
  icon: CustomIcon,
}: ShareButtonProps): ReactElement => {
  const [showShareModal, setShowShareModal] = useState(false);

  return (
    <>
      <Modal
        title="Share this event"
        open={showShareModal}
        onClose={() => {
          setShowShareModal(false);
        }}
      >
        <EventSharingWidget event={event} />
      </Modal>
      <Box
        lineHeight={0}
        sx={{
          cursor: 'pointer',
          WebkitTapHighlightColor: 'rgba(0,0,0,0)',
          display: 'flex',
          alignItems: 'center',
          ...(gap !== undefined && { gap }),
          ...style,
        }}
        className="keyboardFocus"
        onClick={() => {
          setShowShareModal(true);
        }}
        tabIndex={0}
      >
        {CustomIcon ? <CustomIcon /> : <ShareIcon />}
        {children}
      </Box>
    </>
  );
};
